export enum MicrositeEntryScript {
    app =  "app.js",
    index = "index.html"
}
